import { RootState } from '@modules/App/redux/store';
import { FlagListData } from '@modules/HappinessModule/interfaces/FlagListData';
import { AsyncData } from '@shared/interfaces/asyncData';

export const myTeamFlagsDataSelector = (state: RootState): AsyncData<FlagListData[]> =>
  state.happiness.myTeamFlags.myTeamFlagsData;
